import { IPixelDimensions } from '../models/layout';

export function getHtmlElementSize(element: HTMLElement): IPixelDimensions {
	if (element) {
		const boundingClientRect = element.getBoundingClientRect();
		const style = window.getComputedStyle(element);
		const {
			x,
			y,
			bottom,
			top,
			left,
			right,
			height,
			width,
		} = boundingClientRect;
		const boundingClientRectResponse: IPixelDimensions = {
			x,
			y,
			bottom,
			top,
			left,
			right,
			height,
			width,
		};
		if (style.position === 'absolute') {
			boundingClientRectResponse.height = 0;
			boundingClientRectResponse.width = 0;
		}
		else {
			const heightModifiers = ['marginTop', 'marginBottom'];
			boundingClientRectResponse.height = applySizeModifiers(height, heightModifiers, style);
			const widthModifiers = ['marginLeft', 'marginRight'];
			boundingClientRectResponse.width = applySizeModifiers(width, widthModifiers, style);
		}
		return boundingClientRectResponse;
	}
}

export function applySizeModifiers(baseValue: number, modifierKeys: string[], style: CSSStyleDeclaration): number {
	let value = baseValue;
	for (const modifierKey of modifierKeys) {
		const modifierValueRaw = style[modifierKey];
		if (modifierValueRaw) {
			value += getPixelValue(modifierValueRaw);
		}
	}
	return value;
}

export function getPixelValue(value: any): number {
	return parseFloat(value.replace('px', ''));
}